module.exports = __webpack_public_path__ + "img/1529671820.129d67ff.jpg";